<!-- <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-sm">
  <table class="w-full min-w-[1400px] border-collapse ltr:text-left rtl:text-right">
    <thead class="border-b border-gray-200 bg-[#F9FAFB]">
      <tr>
        <th class="w-10 px-2 py-3 text-center text-[12px] font-bold text-gray-500">#</th>
        <th class="px-3 py-3 text-[12px] font-bold text-gray-500">
          @if (productId()) {
            <span i18n="@@stock.colSubProduct">Sub-Product</span>
          } @else {
            <span i18n="@@stock.colProduct">Product</span>
          }
        </th>
        <th class="px-3 py-3 text-[12px] font-bold text-gray-500" i18n="@@stock.colMfgExp">MFG / Expiry Date</th>
        <th class="px-3 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.colPeoplePrice">
          People Price
        </th>
        <th class="px-3 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.Seller">
          Seller Price & Discount
        </th>
        <th class="px-3 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.Pharmacy">
          Pharmacy Price & Discount
        </th>

        <th class="px-3 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.colQty">
          Available / Total Quantity
        </th>
        <th class="px-3 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.colStatus">Status</th>
        <th class="px-3 py-3 text-[12px] font-bold text-gray-500" i18n="@@stock.colModified">Last Modified On / By</th>
        <th class="px-6 py-4 text-center text-[11px] font-bold text-gray-500 uppercase"></th>
      </tr>
    </thead>
    <tbody class="divide-y divide-gray-100">
      @for (item of displayData(); track item.id) {
        @if (item.batchNumber && item.mfgDate && item.expDate) {
          <tr class="transition-colors hover:bg-gray-50">
            <td class="px-2 py-4 text-center text-[12px] font-medium text-gray-500">{{ startItem() + $index }}</td>
            <td class="px-3 py-4">
              <div class="max-w-[200px] truncate text-[12px] font-bold text-gray-800">
                {{ getTranslatedTitle(item.product) }}
              </div>
            </td>
            <td class="px-3 py-4">
              <div class="flex flex-col text-[11px] leading-tight tabular-nums">
                <div class="flex items-center gap-1">
                  <span class="font-bold text-green-600">{{ mfgLabel() }}</span>
                  <span class="font-light">{{ item.mfgDate | date: "MM/yyyy" }}</span>
                </div>

                <div class="flex items-center gap-1">
                  <span
                    class="font-bold"
                    [ngClass]="{
                      'text-red-600': isExpired(item.expDate),
                      'text-orange-500': isNearExpiry(item.expDate),
                    }">
                    {{ expLabel() }}
                  </span>

                  <span
                    [ngClass]="{
                      'text-red-600': isExpired(item.expDate),
                      'text-orange-500': isNearExpiry(item.expDate),
                    }">
                    {{ item.expDate | date: "MM/yyyy" }}
                  </span>
                </div>

                <div class="flex items-center gap-1 text-gray-500">
                  <span class="font-bold">
                    {{ isAr() ? "رقم التشغيلة:" : "Batch No.:" }}
                  </span>
                  <span>{{ item.batchNumber }}</span>
                </div>
              </div>
            </td>
            <td class="px-3 py-4 text-center font-bold text-gray-800">
              {{ item.peoplePrice }}
              <span class="text-[10px] font-medium">{{ currency() }}</span>
            </td>
            <td class="px-3 py-4 text-center text-[13px]">
              <div class="font-bold">
                {{ item.sellerPrice }} {{ currency() }}
                @if (item.sellerPriceDiscountPercentage) {
                  <span class="font-medium">({{ item.sellerPriceDiscountPercentage }}%)</span>
                }
              </div>
            </td>
            <td class="px-3 py-4 text-center text-[13px]">
              <div class="font-bold">
                {{ item.pharmacyPrice }} {{ currency() }}
                @if (item.pharmacyPriceDiscountPercentage) {
                  <span class="font-medium">({{ item.pharmacyPriceDiscountPercentage }}%)</span>
                }
              </div>
            </td>
            <td class="px-3 py-4 text-center font-bold">
              <span class="text-blue-600">{{ item.availableQuantity }}</span>
              / {{ item.totalQuantity }}
            </td>
            <td class="px-3 py-4 text-center">
              <span
                [ngClass]="stockActiveMap().get(item.id) ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'"
                class="inline-flex min-w-[75px] items-center justify-center rounded-full border border-transparent px-2 py-1 text-[10px] font-bold transition-all">
                {{ getStatusLabel(stockActiveMap().get(item.id)!) }}
              </span>
            </td>
            <td class="px-3 py-4 text-[11px]">
              <div class="font-bold">{{ item.lastModifiedBy?.fullName }}</div>
              <div class="text-gray-400">{{ item.lastModifiedOn | date }}</div>
            </td>
            <td class="relative flex justify-center px-6 py-4 text-center text-[13px] font-bold text-gray-800">
              <app-action-icon
                (openDropDown)="openDropDown($event)"
                (closeDropDown)="closeDropDown()"
                [entityId]="item.id"
                type="stock"
                [isOpen]="isDropDown() === item.id" />

              @if (isDropDown() !== null && isDropDown() === item.id) {
                <div
                  [class]="isAr() ? 'left-[40%]' : 'right-[40%]'"
                  class="absolute top-12 z-50 flex w-48 flex-col gap-1 rounded-md border border-gray-200 bg-white p-1 shadow-lg">
                  <button
                    (click)="onNavigateToEditStock($event, item.id)"
                    class="w-full rounded-[4px] px-3 py-2 text-left text-[13px] font-medium text-gray-700 hover:cursor-pointer hover:bg-gray-50"
                    [ngClass]="isAr() ? 'text-right' : 'text-left'"
                    i18n="@@stock.addQuantity">
                    Add Quantity
                  </button>
                  <div
                    *hasScope="[scopes.STOCK.DEACTIVATE, scopes.STOCK.ACTIVATE]"
                    class="flex items-center justify-between"
                    [ngClass]="isAr() ? 'flex-row-reverse' : ''">
                    <app-toggle-button
                      [isActive]="stockActiveMap().get(item.id)"
                      (submit)="onActiveConfirmationModal(stockActiveMap().get(item.id)!, item.id)" />
                    <button
                      (click)="onActiveConfirmationModal(stockActiveMap().get(item.id)!, item.id)"
                      class="w-full rounded-[4px] px-3 py-2 text-[13px] font-medium text-gray-700 hover:cursor-pointer hover:bg-gray-50"
                      [ngClass]="isAr() ? 'text-right' : 'text-left'">
                      @if (stockActiveMap().get(item.id)) {
                        <span i18n="@@deactivatedAction">Mark as inactive</span>
                      } @else {
                        <span i18n="@@activatedAction">Mark as active</span>
                      }
                    </button>
                  </div>
                </div>
              }
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div> -->


<app-tables
  [headerItems]="stockTableColumns()"
  [rows]="stockTableRows()"
  [currentActions]="stockActions()"
  [tableStock]="true"
  [emptyContentTitle]="emptyContentTitle()"
  [emptyContentDescription]="emptyContentDescription()"
  (actionSelected)="onStockAction($event)"
/>


<!-- <div
  class="mt-4 flex flex-col items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4 sm:flex-row"
  [dir]="isAr() ? 'rtl' : 'ltr'">
  <div class="flex items-center gap-3">
    <span class="text-[13px] text-gray-500">{{ isAr() ? "عناصر لكل صفحة:" : "Items per page:" }}</span>
    <select
      [value]="itemsPerPage()"
      (change)="onPageSizeChange($event)"
      class="rounded-md border border-gray-300 bg-white px-2 py-1 text-[13px] outline-none focus:ring-1 focus:ring-[#C42727]">
      <option [value]="25">25</option>
      <option [value]="50">50</option>
      <option [value]="100">100</option>
    </select>
    <div class="ms-4 text-[13px] text-gray-600 tabular-nums">
      {{ isAr() ? "عرض" : "Showing" }}
      <span class="mx-1 font-bold text-[#C42727]">{{ getStartItem() }}-{{ getEndItem() }}</span>
      {{ isAr() ? "من" : "of" }}
      <span class="mx-1 font-bold text-[#C42727]">{{ totalItems() }}</span>
    </div>
  </div>

  <div class="flex items-center gap-1">
    <button
      (click)="previousPage.emit()"
      [disabled]="currentPage() === 1"
      class="flex h-8 w-8 items-center justify-center rounded border border-gray-300 bg-white transition-all hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        class="rtl:rotate-180">
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
    </button>

    @for (page of getPageNumbers(); track $index) {
      @if (page === -1) {
        <span class="px-2 text-gray-400">...</span>
      } @else {
        <button
          (click)="goToPage.emit(page)"
          [class]="
            currentPage() === page
              ? 'border-[#C42727] bg-[#C42727] text-white'
              : 'border-gray-300 bg-white text-gray-600 hover:bg-gray-50'
          "
          class="h-8 w-8 rounded border text-[13px] font-bold tabular-nums transition-all">
          {{ page }}
        </button>
      }
    }

    <button
      (click)="nextPage.emit()"
      [disabled]="currentPage() === totalPages()"
      class="flex h-8 w-8 items-center justify-center rounded border border-gray-300 bg-white transition-all hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        class="rtl:rotate-180">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </button>
  </div>
</div> -->

<app-pagination
  [itemsPerPage]="itemsPerPage()"
  [currentPage]="currentPage() + 1"
  [getPageNumbers]="pageNumbers()"
  [totalPages]="totalPages()"
  [startItem]="startItem()"
  [endItem]="getEndItem()"
  [totalItems]="totalItems()"
  (previousPage)="previousPage.emit()"
  (nextPage)="nextPage.emit()"
  (goToPage)="goToPage.emit($event)"
  (changePageNumber)="onPaginationPageSizeChange($event)"
/>

@if (confirmationModal()) {
  <app-confirmation-dialog
    [error]="errorActivation()"
    (onSubmit)="type() === 'deactivate' ? deactivateStock() : activateStock()"
    (onCancel)="confirmationModal.set(false)"
    [title]="confirmationModalContent()!.title"
    [description]="confirmationModalContent()!.description"
    [confirmContent]="confirmationModalContent()!.confirmContent"
    [type]="type()"
    [cancelContent]="isAr() ? 'إلغاء' : 'Cancel'" />
}

@if (isSuccessNotification()) {
  <app-successful-notification
    type="success"
    [title]="
      isAr()
        ? type() === 'deactivate'
          ? 'تم إلغاء تفعيل المخزون'
          : 'تم تفعيل المخزون'
        : type() === 'deactivate'
          ? 'Stock deactivated successfully. The stock is now hidden from customers.'
          : 'Stock activated successfully. The stock is now visible to customers.'
    " />
}
